import { LocalizedText } from '@mews/framework';

interface Props {
    textKey: Mews.TextKey;
}

const Warning: React.FC<Props> = ({ textKey }) => (
    <div className="alert">
        <LocalizedText textKey={textKey} />
    </div>
);

export default Warning;
